<template>
  <div class="content">
    <!-- 	<van-nav-bar title="门票预约"/> -->
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(item, index) in images" :key="index">
        <el-image style="width: 100%; height: 200px" :src="item.headPhoto"></el-image>
      </van-swipe-item>
    </van-swipe>

    <van-loading type="spinner" class='loading' color="#1989fa" />
    <van-row>
      <span class="title_" style="">
        <van-col span="22" offset="1" style="">
          <van-col span="24">
            <van-col span="18" offset="1" style="margin-top:10px;">
              <van-col span="18" class="text_scenicarea"> {{scenicArea}}</van-col>
            </van-col>
          </van-col>
          <van-col span="24">
            <van-col span="18" offset="1" style="margin-top:5px;">
              <van-col span="18" class="">
                <span class="text_remark" style="">
                  {{remark}}
                </span>

              </van-col>
            </van-col>
          </van-col>
          <van-col span="24" style="margin-top:3px;">
            <van-col span="2" offset="1" style="margin-top:7px;">
              <van-icon name="clock-o" color="" style="font-size:13px" />
            </van-col>
            <van-col span="18" style="margin-top: 5px; font-size:14px;">
              <van-col span="18" style="margin-top: 3px; font-size: 14px; margin-left:-8px ; color: #333333FF;">开园时间：
                {{qupiao}}</van-col>
            </van-col>
          </van-col>

          <van-col span="24">
            <van-col span="2" style="margin-top:7px;" offset="1">
              <van-icon name="location-o" color="" style="font-size:13px" />
            </van-col>
            <van-col span="18" style="margin-top:8px; font-size: 14px;  margin-left:-8px ; color: #333333; ">{{dizhi}}
            </van-col>
          </van-col>

          <van-col span="24" style="margin-bottom:4px;">
            <van-col span="2" offset="1" style="margin-top:8px;">
              <van-icon name="phone-o" color="" style="font-size:13px" />
            </van-col>
            <van-col span="18" style="margin-top:8px; font-size: 14x;  margin-left:-8px ; color: #333333; ">
              {{directionsForUse}}</van-col>
          </van-col>
        </van-col>
      </span>
    </van-row>

    <van-row>
      <van-col span="24" style="height: 10px;background-color: #F4F5F7;">
      </van-col>
    </van-row>
    <van-row>
      <!-- 	<van-col  span="24">
					<van-col  span="20" style="height: 80px;margin-top:10px;  background-color:#FF4A5317 ;" offset="2">
						<van-col span="11" style="text-align: center; margin-top: 18px;" >
							<van-col span="24" >
								<span  style="color:#FF4A53 ;font-size: 14px; font-weight: 600;">入园时间</span>
							</van-col>
							 <van-col span="24" style="margin-top: 6px; font-size: 14px;">
								<span style="color:#666666 ;font-size: 14px; ">{{qupiao}}</span>
							</van-col>
						</van-col>
					   <van-col span="2"  style="text-align: center; margin-top: 18px;">
						   <span style="border-left:1px dashed #000; height:40px;width:2px;display: inline-block;"></span>
						</van-col>

						<van-col span="11"  style="text-align: center; margin-top: 18px;">
							<van-col span="24" >
								<span style="color:#FF4A53 ;font-size: 14px; font-weight: 600;">开园时间</span>
							</van-col>
							 <van-col span="24" style="margin-top: 6px; font-size: 14px;">
								<span  style="color:#666666 ;font-size: 14px;">{{qupiao}}</span>
							</van-col>
						</van-col>
					</van-col>
				</van-col> -->

      <van-col span="24">
          <van-col offset="1" span="22" style=" margin-bottom: 10px;margin-top:1px;">
            <span @click="sk()">
              <van-image width="100%" height="90px" src="../../../static/yuding.png" />
            </span>
            <!-- <van-button   type="info" block  round class="" style="font-size: 14px; color: #FFFFFF; background-color:#FF4A53 ;border:1px solid #FF4A53;">门票预约</van-button> -->

            <!-- <van-button   type="info" block  @click="sk()" class="">门票预约</van-button> -->
        </van-col>
     <!--    <van-col offset="1" span="22" style=" margin-bottom: 10px;margin-top:1px;">
            <span @click="tt()">
              <van-image width="100%" height="90px" src="../../../static/yutt.png" />
            </span>
        </van-col> -->
      </van-col>

      <van-col span="24">
        <van-col offset="2" span="20">
          <van-col span="24">
            <span class="text_x">预订须知:</span>
          </van-col>
          <van-col span="24" style="margin-top: 10px; font-size: 15px; color: #999999FF;">
            {{yuding}}
          </van-col>
        </van-col>
        <van-col offset="2" span="20" style="padding-bottom: 50px; ">
          <van-col span="24" style="margin-top:10px;">

            <span class="text_x">景区介绍:</span>
          </van-col>
          <van-col span="24" style="margin-top:10px; font-size:15px; color: #999999FF;">
            {{jieshao}}
          </van-col>
        </van-col>
      </van-col>
    </van-row>
    <van-tabbar v-model="active" active-color="#FF4A53">
      <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
      <van-tabbar-item icon="setting-o" @click="user()">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        hide: false,
        images: [],
        phone: '',
        active: 0,
        text: '',
        message: '',
        scenicArea: '',
        code: '',
        show: false,
        endshow: false,
        isLoadingShow: true,
        className: '',
        jieshao: '',
        remark: '',
        dizhi: '',
        tuigai: '',
        qupiao: '',
        directionsForUse: '',
        scenicAreaID: '',
        yuding: '',
        endclassName: ''
      }
    },
    mounted() {

      this.userlista();


    },
    methods: {
      xxquery() {
       let storage = window.sessionStorage;
       let token = storage.getItem("token")
        let scenicAreaID = storage.getItem("scenicAreaID")

        this.$axios({
            url: "/api/wechatPublicConfig",
            method: "get",
            params: {
              pageItems: 999, //每页显示的条数
              pageNumber: 1, //页数
              scenicAreaID: scenicAreaID,

            },
            headers: {
              "authorization": token,
              "Content-Type": "application/json; charset=utf-8"
            }
          })
          .then(res => {
            var data = res.data[0];
            //this.headr=data[0].serviceTel;
            // this.xxid=data[0].id;
            console.log(data)
            this.scenicArea = data[0].scenicArea.name;
            this.jieshao = data[0].scenicIntroduction;
            this.dizhi = data[0].scenicAddress;
            this.yuding = data[0].dueToThat;
            this.tuigai = data[0].backToThat;
            this.qupiao = data[0].takeTicketAddress;
            this.directionsForUse = data[0].directionsForUse;
            this.remark = data[0].scenicArea.remark;
          })
          .catch(err => {
            console.log(err);
          });
      },
      sk() {
        this.$router.push({
          path: "/wx_ticketList"
        });
      },
      tt() {
        this.$router.push({
          path: "/wx_ticketGroup"
        });
      },
      home() {
        this.$router.push({
          path: "/wx_ticketIndex"
        });
      },
      user() {
        //window.location.href = '/wx_ticketUser';
        this.$router.push({
          path: "/wx_ticketUser"
        });
      },

      userlista() {
        let storage=window.sessionStorage;
        let token = storage.getItem("token")
        let openida = storage.getItem("openid");
        if (openida == null || openida == "null" || openida == "undefined" || openida == undefined || openida == "") {
          this.$axios({
              url: "/api/wechat/findWXUser",
              method: "get",
              params: {

              },
              headers: {
                "authorization": token,
                "Content-Type": "application/json; charset=utf-8"
              }
            })
            .then(res => {
              let data = res.data;
              console.log(data);
              if (data.length > 0) {
                let open_id = data[0].openid;
                //let open_id = "oQ0qr54VNP2Xov6RMhP1vpuAlm8s";
                let scenicAreaID = data[0].scenicAreaID;
                let appid = data[0].remarks;
                //let isUnattendedMode= data[0].isUnattendedMode;
                //let openida ="oEwwHxEjiA-Hs9yx1xjcggmNR3bI";
                storage.setItem("openid", open_id);
                storage.setItem("appid", appid);
                storage.setItem("scenicAreaID", scenicAreaID);
                //storage.setItem("isUnattendedMode",isUnattendedMode);
                this.imageslist();
                this.xxquery();

              } else {
                alert("openID获取失败，请退出公众号在进入购票中心");
                // storage.setItem("openid","oHLen6A-ckrtYEwDVx3frYUXB4Z0");
                // storage.setItem("scenicAreaID","34");
                this.imageslist();
                this.xxquery();
              }

            })
            .catch(err => {
              console.log(err);
            });
        } else {
          //storage.setItem("openid","oHLen6A-ckrtYEwDVx3frYUXB4Z0");
          //storage.setItem("scenicAreaID","34");
          this.imageslist();
          this.xxquery();

          //	console.log("11111111111")
        }
      },

      imageslist() {
        let storage=window.sessionStorage;
        let token = storage.getItem("token")
        let scenicAreaID = storage.getItem("scenicAreaID")
        this.$axios({
            url: "/api/wechatPublicConfig/carouselList",
            method: "get",
            params: {
              pageItems: 999, //每页显示的条数
              pageNumber: 1, //页数
              scenicAreaID: scenicAreaID,
            },
            headers: {
              "authorization": token,
              "Content-Type": "application/json; charset=utf-8"
            }
          })
          .then(res => {
            var data = res.data[0];
            this.images = [];

            for (const i in data) {
              var headPhoto = "";
              if (data[i].imagePath) {
                headPhoto = "/api/image?url=" + data[i].imagePath;

              }
              this.images.push({
                headPhoto
              });


            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      showPopup() {
        this.show = true
        this.isLoadingShow = true
        setTimeout(() => {
          this.isLoadingShow = false
        }, 500)
      },
      endshowPopup() {
        this.endshow = true
        this.isLoadingShow = true
        setTimeout(() => {
          this.isLoadingShow = false
        }, 500)
      },

    }

  }
</script>

<style scoped>
  .text_remark {
    font-size: 12px;
    background-color: #FEE6E5FF;
    color: #CF1322FF;
    padding: 0 3px;
  }

  .text_scenicarea {
    font-weight: 600;

    font-size: 18px;
    margin-top: 6px;
    color: #333333;

  }

  .title_ {
    display: inline-block;
    background-color: #FFFFFF;
    position: relative;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    margin-top: -18px;
    z-index: 9999;
  }

  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #FF4A53;
  }

  img {
    width: 100%;
    height: 200px;
  }

  .text_color {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #FF4A53;
  }

  .text_x {
    display: inline-block;
    font-weight: 600;
    color: #333333;
    font-size: 16px;

  }

  .icon_color1 i {
    color: #1989fa;
  }

  .icon_color2 i {
    color: #19c160;
  }

  .icon_color3 i {
    color: #07c160;
  }

  .icon_color4 i {
    color: #4fc08d;
  }

  .icon_color5 i {
    color: #2989fa;
  }

  .content {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
  }

  .box {
    width: 90%;
    margin-top: 20px;
    margin-left: 5%;
    background-color: #97CBFF;
  }

  .box_header {
    height: 40px;
    line-height: 40px;
    color: #000000;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    background-color: #F0EFED;
  }


  .router {
    color: #646566;
  }

  .activerouter {
    color: #1989fa;
  }

  .loading {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/system/index/wechatlist/wx_ticketIndex.vue